import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const addTimeOffTeamLeaderNote = async (
	port: TimeOffPort,
	id: string,
	authorId: string,
	authorName: string,
	note: string,
	notify: NotifyPort,
): Promise<TimeOffRequest> => {
	try {
		const request = await port.addTeamLeaderNote(id, authorId, authorName, note)
		notify.success('hr.noteAdded')
		return request
	} catch {
		notify.error('hr.noteAddFailed')
		throw new Error('Failed to add note.')
	}
}

export { addTimeOffTeamLeaderNote }
